const baseURL = "https://ama-wuzengfu.herokuapp.com";
module.exports = baseURL;
